export const render = (fn: () => JSX.Element | null): JSX.Element | null => {
  return fn();
};

export const value: <T>(fn: () => T) => T = (fn) => {
  return fn();
};
